function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: -0.000488281,
  y: 0.82962,
  width: 35.0005,
  height: 35.4213,
  rx: 3,
  fill: "#201D2F",
  fillOpacity: 1
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27 23.0944C24.8307 23.0944 22.9849 21.9181 22.1914 21.2129C22.1061 21.1372 21.9753 21.1411 21.8944 21.2215C21.1835 21.9276 19.5106 23.0944 17.4401 23.0944C15.3005 23.0944 13.4797 21.9211 12.6945 21.2156C12.6089 21.1387 12.4768 21.1427 12.3956 21.2242C11.6921 21.9306 10.0417 23.0944 7.99963 23.0944",
  stroke: "#F0F0F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M27 27.1426C24.8307 27.1426 22.9849 25.9663 22.1914 25.2611C22.1061 25.1853 21.9753 25.1893 21.8944 25.2697C21.1835 25.9758 19.5106 27.1426 17.4401 27.1426C15.3005 27.1426 13.4797 25.9692 12.6945 25.2637C12.6089 25.1868 12.4768 25.1908 12.3956 25.2724C11.6921 25.9787 10.0417 27.1426 7.99963 27.1426",
  stroke: "#F0F0F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M23.4805 15.2411L17.2403 8.9259L11.0001 15.2411L12.04 16.2942L17.2403 11.0307L22.4406 16.2942L23.4805 15.2411Z",
  fill: "#F0F0F5"
});

function SvgAbove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 37,
    viewBox: "0 0 35 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbove);
export default __webpack_public_path__ + "static/media/above.75fe8891.svg";
export { ForwardRef as ReactComponent };